<modal
  class="InfoModal"
  [condition]="showInfo"
  [config]="{
    type: 'flyout',
    size: 'medium',
    header: {
      title: 'What\'s This?',
      showClose: false
    },
    direction: 'bottom'
  }"
>
  <ng-container
    body
    [ngTemplateOutlet]="whichInfo === 'labels' ? Labels : Notes"
  >
  </ng-container>

  <ng-container footer>
    <zip-button
      class="InfoModal__Button"
      [config]="doneButtonConfig"
      (click)="handleClose()"
    ></zip-button>
  </ng-container>
</modal>

<!-- OUTPUT TEMPLATES -->

<ng-template #Notes>
  <p>
    Add a note about your claim so you can remember important details later.
  </p>
</ng-template>

<ng-template #Labels>
  <p>
    Labels allow you to organize and filter claims easily. Add up to 5 labels to
    each claim and they will appear in your claim filter to easily find later.
  </p>
  <p class="InfoModal__TopMargin">Example Labels:</p>
  <ul class="InfoModal__List">
    <li class="InfoModal__ListItem">Broken Wrist</li>
    <li class="InfoModal__ListItem">Sprained Ankle</li>
    <li class="InfoModal__ListItem">Flu Shot</li>
  </ul>
</ng-template>
